import React, { useEffect } from "react";
import styles from "./ExitConfirmModal.module.css";

/*
 * ExitConfirmModal — shown when the user tries to Back out of an
 * incomplete post-payment setup flow. Confirms before leaving to the
 * dashboard so a stray back gesture doesn't drop them mid-setup (and
 * never lands them on the expired Stripe page).
 */
export default function ExitConfirmModal({
  open,
  onStay,
  onLeave,
  title = "Your setup isn't finished",
  body = "You're in the middle of setting up your AI receptionist. Leave now and you can finish later from your dashboard.",
  stayLabel = "Keep setting up",
  leaveLabel = "Leave setup",
}) {
  useEffect(() => {
    if (!open) return undefined;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, [open]);

  if (!open) return null;

  return (
    <div className={styles.backdrop} role="dialog" aria-modal="true">
      <div className={styles.sheet}>
        <h3 className={styles.title}>{title}</h3>
        <p className={styles.body}>{body}</p>
        <div className={styles.actions}>
          <button type="button" className={styles.stayBtn} onClick={onStay}>
            {stayLabel}
          </button>
          <button type="button" className={styles.leaveBtn} onClick={onLeave}>
            {leaveLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
